import SerializableObject from '@/utils/models/serializableobject.model';
import Product from '../menu/product.model';

export class ProductFavoriteResponse extends SerializableObject {
  FavoriteProductList: Product[] = [];
}
